<template>
<div class="p-hc-bg">
  <div class="p-hc">
    <div class="p-hc-tit">
      <div class="title">{{baseData.title}}</div>
    </div>
    <div class="p-hc-box">
      <VueSlickCarousel v-bind="settings1">
        <div
          class="li"
          v-for="(item, i) in baseData.list1"
          :key="i"
        >
          <div class="li-box">
            <div class="img">
              <img :src="item.icon" alt="">
            </div>
            <p>{{item.title}}</p>
          </div>
        </div>
      </VueSlickCarousel>
      <VueSlickCarousel v-bind="settings2">
        <div
          class="li"
          v-for="(item, i) in baseData.list2"
          :key="i"
        >
          <div class="li-box">
            <div class="img">
              <img :src="item.icon" alt="">
            </div>
            <p>{{item.title}}</p>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</div>
</template>

<script>
import {customData} from '../config'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
// customData.list1 = [...customData.list1, ...customData.list1]
// customData.list2 = [...customData.list2, ...customData.list2]

export default {
  name: 'custom-component',
  components: {VueSlickCarousel},
  data () {
    return {
      baseData: customData,
      settings1: {
        infinite: true,
        centerMode: false,
        centerPadding: '20px',
        slidesToSroll: 1,
        slidesToShow: 1,
        variableWidth: true,
        autoplay: true,
        speed: 15000,
        arrows: false,
        cssEase: 'linear',
        draggable: false
      },
      settings2: {
        infinite: true,
        centerMode: false,
        centerPadding: '20px',
        slidesToSroll: 1,
        slidesToShow: 1,
        variableWidth: true,
        autoplay: true,
        speed: 15000,
        arrows: false,
        cssEase: 'linear',
        rtl: true,
        draggable: false
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.p-hc-bg{
  background-color: #fcfcfc;
}
.p-hc{
  height: 700px;
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  &-tit{
    height: 188px;
    font-weight: 700;
    font-size: 36px;
    line-height: 200px;
    text-align: center;
    color: rgba(13, 13, 13, 0.9);
    .title{
      font-weight: 700;
      font-size: 36px;
    }
  }
  
  &-box{
    width: 100%;
    height: 408px;
    position: relative;
    &::before, &::after{
      content: "";
      width: 30%;
      height: 100%;
      background-image: -webkit-linear-gradient(right,#ffffff00 0,#fcfcfc 67%);
      background-image: linear-gradient(270deg,hsla(0,0%,100%,0),#fcfcfc 67%);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      @media screen and (max-width: $width-xl) {
        width: 120px;
      }
    }
    &::after{
      right: 0px;
      left: auto;
      transform: rotate(-180deg);
    }
    .li{
      width: 204px;
      height: 204px;
      padding: 12px;
      display: inline-block;
      &-box{
        width: 100%;
        height: 100%;
        background-color: white;
        box-shadow: 0px 1px 2px rgba(116, 134, 163, 0.04), 0px 4px 30px rgba(116, 134, 163, 0.1);
        box-shadow: 0px 1px 2px rgba(116, 134, 163, 0.04), 0px 2px 15px rgba(116, 134, 163, 0.1);
        border-radius: 16px;
        text-align: center;
        padding-top: 24px;
        .img{
          width: 180px;
          height: 100px;
          img{
            width: 100px;
            height: 100px;
            display: inline-block;
          }
        }
        p{
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          color: #000000;
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
